import getDefaultMenu, { getMenuProps as defaultGetMenuProps } from '../../components/Post/menu'
import capitalize from '../../utils/capitalize'

// A `_status` ennél a posttípusnál gyári szerepben marad: csak a törlés és a
// visszaállítás használja, ezért a `ban`, a `featured` és a gyári `approve`
// resolver le van tiltva. A partner elfogadása a `partnerState` mezőre épül,
// és saját gombbal érhető el az adatlapon (Content/sync.js), nem a menüből.
const ENABLED_KEYS = ['edit', 'delete']

export function getMenuProps(p) {
    return defaultGetMenuProps(p)
}

function getMenu(props = {}) {
    const N = capitalize(props.name)
    const enabledLabels = ENABLED_KEYS.map((k) => props.appContext.menus[k + N + 'Menu'])

    return getDefaultMenu(props).filter((menu) => enabledLabels.includes(menu.label))
}

export default getMenu
